/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as RegistrationCompletionRouteImport } from './routes/registration-completion'
import { Route as NoAccountRouteImport } from './routes/no-account'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password/$token'
import { Route as AuthVerifiedAdviserScoresRouteImport } from './routes/_auth/verified-adviser-scores'
import { Route as AuthRiskAndOpportunitySettingsRouteImport } from './routes/_auth/risk-and-opportunity-settings'
import { Route as AuthReviewSettingsRouteImport } from './routes/_auth/review-settings'
import { Route as AuthReportingRouteImport } from './routes/_auth/reporting'
import { Route as AuthPerformanceOverTimeRouteImport } from './routes/_auth/performance-over-time'
import { Route as AuthPerformanceFirmOverTimeRouteImport } from './routes/_auth/performance-firm-over-time'
import { Route as AuthPerformanceFirmRouteImport } from './routes/_auth/performance-firm'
import { Route as AuthPerformanceAdviserOverTimeRouteImport } from './routes/_auth/performance-adviser-over-time'
import { Route as AuthPerformanceAdviserRouteImport } from './routes/_auth/performance-adviser'
import { Route as AuthInviteRequestsRouteImport } from './routes/_auth/invite-requests'
import { Route as AuthInviteHistoryRouteImport } from './routes/_auth/invite-history'
import { Route as AuthFreeTextAnalysisRouteImport } from './routes/_auth/free-text-analysis'
import { Route as AuthAdviserReputationalToolsRouteImport } from './routes/_auth/adviser-reputational-tools'
import { Route as AuthTopRatedStatusIndexRouteImport } from './routes/_auth/top-rated-status/index'
import { Route as AuthTopRatedAdviserIndexRouteImport } from './routes/_auth/top-rated-adviser/index'
import { Route as AuthToolsIndexRouteImport } from './routes/_auth/tools/index'
import { Route as AuthReviewsIndexRouteImport } from './routes/_auth/reviews/index'
import { Route as AuthProfileIndexRouteImport } from './routes/_auth/profile/index'
import { Route as AuthProfessionalsIndexRouteImport } from './routes/_auth/professionals/index'
import { Route as AuthEnquiriesIndexRouteImport } from './routes/_auth/enquiries/index'
import { Route as AuthBulkInviteIndexRouteImport } from './routes/_auth/bulk-invite/index'
import { Route as AuthArticlesIndexRouteImport } from './routes/_auth/articles/index'
import { Route as AuthAdvisersIndexRouteImport } from './routes/_auth/advisers/index'
import { Route as AuthReportRiskRouteImport } from './routes/_auth/report/risk'
import { Route as AuthReportOpportunityRouteImport } from './routes/_auth/report/opportunity'
import { Route as AuthProfessionalsPerformanceRouteImport } from './routes/_auth/professionals/performance'
import { Route as AuthNetworkFirmsPerformanceRouteImport } from './routes/_auth/network/firms-performance'
import { Route as AuthEnquiriesIdRouteImport } from './routes/_auth/enquiries/$id'
import { Route as AuthElevationFirmPerformanceRouteImport } from './routes/_auth/elevation/firm-performance'
import { Route as AuthBulkInviteIdRouteImport } from './routes/_auth/bulk-invite/$id'
import { Route as AuthArticlesArticleIdRouteImport } from './routes/_auth/articles/$articleId'
import { Route as AuthAdvisersIdRouteImport } from './routes/_auth/advisers/$id'
import { Route as AuthTopRatedStatusCompareFirmsIndexRouteImport } from './routes/_auth/top-rated-status/compare-firms/index'
import { Route as AuthReviewsReviewIdRouteImport } from './routes/_auth/reviews/review/$id'
import { Route as AuthReviewsFirstImpressionIdRouteImport } from './routes/_auth/reviews/first-impression/$id'
import { Route as AuthEnquiriesReportIdRouteImport } from './routes/_auth/enquiries/report/$id'
import { Route as AuthElevationProfessionalsElevationPerformanceRouteImport } from './routes/_auth/elevation/professionals/elevation-performance'

const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationCompletionRoute = RegistrationCompletionRouteImport.update({
  id: '/registration-completion',
  path: '/registration-completion',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccountRoute = NoAccountRouteImport.update({
  id: '/no-account',
  path: '/no-account',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifiedAdviserScoresRoute =
  AuthVerifiedAdviserScoresRouteImport.update({
    id: '/verified-adviser-scores',
    path: '/verified-adviser-scores',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRiskAndOpportunitySettingsRoute =
  AuthRiskAndOpportunitySettingsRouteImport.update({
    id: '/risk-and-opportunity-settings',
    path: '/risk-and-opportunity-settings',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReviewSettingsRoute = AuthReviewSettingsRouteImport.update({
  id: '/review-settings',
  path: '/review-settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportingRoute = AuthReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceOverTimeRoute = AuthPerformanceOverTimeRouteImport.update({
  id: '/performance-over-time',
  path: '/performance-over-time',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceFirmOverTimeRoute =
  AuthPerformanceFirmOverTimeRouteImport.update({
    id: '/performance-firm-over-time',
    path: '/performance-firm-over-time',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceFirmRoute = AuthPerformanceFirmRouteImport.update({
  id: '/performance-firm',
  path: '/performance-firm',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerformanceAdviserOverTimeRoute =
  AuthPerformanceAdviserOverTimeRouteImport.update({
    id: '/performance-adviser-over-time',
    path: '/performance-adviser-over-time',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPerformanceAdviserRoute = AuthPerformanceAdviserRouteImport.update({
  id: '/performance-adviser',
  path: '/performance-adviser',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteRequestsRoute = AuthInviteRequestsRouteImport.update({
  id: '/invite-requests',
  path: '/invite-requests',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteHistoryRoute = AuthInviteHistoryRouteImport.update({
  id: '/invite-history',
  path: '/invite-history',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFreeTextAnalysisRoute = AuthFreeTextAnalysisRouteImport.update({
  id: '/free-text-analysis',
  path: '/free-text-analysis',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdviserReputationalToolsRoute =
  AuthAdviserReputationalToolsRouteImport.update({
    id: '/adviser-reputational-tools',
    path: '/adviser-reputational-tools',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthTopRatedStatusIndexRoute = AuthTopRatedStatusIndexRouteImport.update({
  id: '/top-rated-status/',
  path: '/top-rated-status/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTopRatedAdviserIndexRoute =
  AuthTopRatedAdviserIndexRouteImport.update({
    id: '/top-rated-adviser/',
    path: '/top-rated-adviser/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthToolsIndexRoute = AuthToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReviewsIndexRoute = AuthReviewsIndexRouteImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileIndexRoute = AuthProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfessionalsIndexRoute = AuthProfessionalsIndexRouteImport.update({
  id: '/professionals/',
  path: '/professionals/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEnquiriesIndexRoute = AuthEnquiriesIndexRouteImport.update({
  id: '/enquiries/',
  path: '/enquiries/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBulkInviteIndexRoute = AuthBulkInviteIndexRouteImport.update({
  id: '/bulk-invite/',
  path: '/bulk-invite/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthArticlesIndexRoute = AuthArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdvisersIndexRoute = AuthAdvisersIndexRouteImport.update({
  id: '/advisers/',
  path: '/advisers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportRiskRoute = AuthReportRiskRouteImport.update({
  id: '/report/risk',
  path: '/report/risk',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportOpportunityRoute = AuthReportOpportunityRouteImport.update({
  id: '/report/opportunity',
  path: '/report/opportunity',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfessionalsPerformanceRoute =
  AuthProfessionalsPerformanceRouteImport.update({
    id: '/professionals/performance',
    path: '/professionals/performance',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthNetworkFirmsPerformanceRoute =
  AuthNetworkFirmsPerformanceRouteImport.update({
    id: '/network/firms-performance',
    path: '/network/firms-performance',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEnquiriesIdRoute = AuthEnquiriesIdRouteImport.update({
  id: '/enquiries/$id',
  path: '/enquiries/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthElevationFirmPerformanceRoute =
  AuthElevationFirmPerformanceRouteImport.update({
    id: '/elevation/firm-performance',
    path: '/elevation/firm-performance',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBulkInviteIdRoute = AuthBulkInviteIdRouteImport.update({
  id: '/bulk-invite/$id',
  path: '/bulk-invite/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthArticlesArticleIdRoute = AuthArticlesArticleIdRouteImport.update({
  id: '/articles/$articleId',
  path: '/articles/$articleId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdvisersIdRoute = AuthAdvisersIdRouteImport.update({
  id: '/advisers/$id',
  path: '/advisers/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTopRatedStatusCompareFirmsIndexRoute =
  AuthTopRatedStatusCompareFirmsIndexRouteImport.update({
    id: '/top-rated-status/compare-firms/',
    path: '/top-rated-status/compare-firms/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReviewsReviewIdRoute = AuthReviewsReviewIdRouteImport.update({
  id: '/reviews/review/$id',
  path: '/reviews/review/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReviewsFirstImpressionIdRoute =
  AuthReviewsFirstImpressionIdRouteImport.update({
    id: '/reviews/first-impression/$id',
    path: '/reviews/first-impression/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthEnquiriesReportIdRoute = AuthEnquiriesReportIdRouteImport.update({
  id: '/enquiries/report/$id',
  path: '/enquiries/report/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthElevationProfessionalsElevationPerformanceRoute =
  AuthElevationProfessionalsElevationPerformanceRouteImport.update({
    id: '/elevation/professionals/elevation-performance',
    path: '/elevation/professionals/elevation-performance',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-account': typeof NoAccountRoute
  '/registration-completion': typeof RegistrationCompletionRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/adviser-reputational-tools': typeof AuthAdviserReputationalToolsRoute
  '/free-text-analysis': typeof AuthFreeTextAnalysisRoute
  '/invite-history': typeof AuthInviteHistoryRoute
  '/invite-requests': typeof AuthInviteRequestsRoute
  '/performance-adviser': typeof AuthPerformanceAdviserRoute
  '/performance-adviser-over-time': typeof AuthPerformanceAdviserOverTimeRoute
  '/performance-firm': typeof AuthPerformanceFirmRoute
  '/performance-firm-over-time': typeof AuthPerformanceFirmOverTimeRoute
  '/performance-over-time': typeof AuthPerformanceOverTimeRoute
  '/reporting': typeof AuthReportingRoute
  '/review-settings': typeof AuthReviewSettingsRoute
  '/risk-and-opportunity-settings': typeof AuthRiskAndOpportunitySettingsRoute
  '/verified-adviser-scores': typeof AuthVerifiedAdviserScoresRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/advisers/$id': typeof AuthAdvisersIdRoute
  '/articles/$articleId': typeof AuthArticlesArticleIdRoute
  '/bulk-invite/$id': typeof AuthBulkInviteIdRoute
  '/elevation/firm-performance': typeof AuthElevationFirmPerformanceRoute
  '/enquiries/$id': typeof AuthEnquiriesIdRoute
  '/network/firms-performance': typeof AuthNetworkFirmsPerformanceRoute
  '/professionals/performance': typeof AuthProfessionalsPerformanceRoute
  '/report/opportunity': typeof AuthReportOpportunityRoute
  '/report/risk': typeof AuthReportRiskRoute
  '/advisers/': typeof AuthAdvisersIndexRoute
  '/articles/': typeof AuthArticlesIndexRoute
  '/bulk-invite/': typeof AuthBulkInviteIndexRoute
  '/enquiries/': typeof AuthEnquiriesIndexRoute
  '/professionals/': typeof AuthProfessionalsIndexRoute
  '/profile/': typeof AuthProfileIndexRoute
  '/reviews/': typeof AuthReviewsIndexRoute
  '/tools/': typeof AuthToolsIndexRoute
  '/top-rated-adviser/': typeof AuthTopRatedAdviserIndexRoute
  '/top-rated-status/': typeof AuthTopRatedStatusIndexRoute
  '/elevation/professionals/elevation-performance': typeof AuthElevationProfessionalsElevationPerformanceRoute
  '/enquiries/report/$id': typeof AuthEnquiriesReportIdRoute
  '/reviews/first-impression/$id': typeof AuthReviewsFirstImpressionIdRoute
  '/reviews/review/$id': typeof AuthReviewsReviewIdRoute
  '/top-rated-status/compare-firms/': typeof AuthTopRatedStatusCompareFirmsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-account': typeof NoAccountRoute
  '/registration-completion': typeof RegistrationCompletionRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/adviser-reputational-tools': typeof AuthAdviserReputationalToolsRoute
  '/free-text-analysis': typeof AuthFreeTextAnalysisRoute
  '/invite-history': typeof AuthInviteHistoryRoute
  '/invite-requests': typeof AuthInviteRequestsRoute
  '/performance-adviser': typeof AuthPerformanceAdviserRoute
  '/performance-adviser-over-time': typeof AuthPerformanceAdviserOverTimeRoute
  '/performance-firm': typeof AuthPerformanceFirmRoute
  '/performance-firm-over-time': typeof AuthPerformanceFirmOverTimeRoute
  '/performance-over-time': typeof AuthPerformanceOverTimeRoute
  '/reporting': typeof AuthReportingRoute
  '/review-settings': typeof AuthReviewSettingsRoute
  '/risk-and-opportunity-settings': typeof AuthRiskAndOpportunitySettingsRoute
  '/verified-adviser-scores': typeof AuthVerifiedAdviserScoresRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/': typeof AuthIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/advisers/$id': typeof AuthAdvisersIdRoute
  '/articles/$articleId': typeof AuthArticlesArticleIdRoute
  '/bulk-invite/$id': typeof AuthBulkInviteIdRoute
  '/elevation/firm-performance': typeof AuthElevationFirmPerformanceRoute
  '/enquiries/$id': typeof AuthEnquiriesIdRoute
  '/network/firms-performance': typeof AuthNetworkFirmsPerformanceRoute
  '/professionals/performance': typeof AuthProfessionalsPerformanceRoute
  '/report/opportunity': typeof AuthReportOpportunityRoute
  '/report/risk': typeof AuthReportRiskRoute
  '/advisers': typeof AuthAdvisersIndexRoute
  '/articles': typeof AuthArticlesIndexRoute
  '/bulk-invite': typeof AuthBulkInviteIndexRoute
  '/enquiries': typeof AuthEnquiriesIndexRoute
  '/professionals': typeof AuthProfessionalsIndexRoute
  '/profile': typeof AuthProfileIndexRoute
  '/reviews': typeof AuthReviewsIndexRoute
  '/tools': typeof AuthToolsIndexRoute
  '/top-rated-adviser': typeof AuthTopRatedAdviserIndexRoute
  '/top-rated-status': typeof AuthTopRatedStatusIndexRoute
  '/elevation/professionals/elevation-performance': typeof AuthElevationProfessionalsElevationPerformanceRoute
  '/enquiries/report/$id': typeof AuthEnquiriesReportIdRoute
  '/reviews/first-impression/$id': typeof AuthReviewsFirstImpressionIdRoute
  '/reviews/review/$id': typeof AuthReviewsReviewIdRoute
  '/top-rated-status/compare-firms': typeof AuthTopRatedStatusCompareFirmsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/no-account': typeof NoAccountRoute
  '/registration-completion': typeof RegistrationCompletionRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/_auth/adviser-reputational-tools': typeof AuthAdviserReputationalToolsRoute
  '/_auth/free-text-analysis': typeof AuthFreeTextAnalysisRoute
  '/_auth/invite-history': typeof AuthInviteHistoryRoute
  '/_auth/invite-requests': typeof AuthInviteRequestsRoute
  '/_auth/performance-adviser': typeof AuthPerformanceAdviserRoute
  '/_auth/performance-adviser-over-time': typeof AuthPerformanceAdviserOverTimeRoute
  '/_auth/performance-firm': typeof AuthPerformanceFirmRoute
  '/_auth/performance-firm-over-time': typeof AuthPerformanceFirmOverTimeRoute
  '/_auth/performance-over-time': typeof AuthPerformanceOverTimeRoute
  '/_auth/reporting': typeof AuthReportingRoute
  '/_auth/review-settings': typeof AuthReviewSettingsRoute
  '/_auth/risk-and-opportunity-settings': typeof AuthRiskAndOpportunitySettingsRoute
  '/_auth/verified-adviser-scores': typeof AuthVerifiedAdviserScoresRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/_auth/advisers/$id': typeof AuthAdvisersIdRoute
  '/_auth/articles/$articleId': typeof AuthArticlesArticleIdRoute
  '/_auth/bulk-invite/$id': typeof AuthBulkInviteIdRoute
  '/_auth/elevation/firm-performance': typeof AuthElevationFirmPerformanceRoute
  '/_auth/enquiries/$id': typeof AuthEnquiriesIdRoute
  '/_auth/network/firms-performance': typeof AuthNetworkFirmsPerformanceRoute
  '/_auth/professionals/performance': typeof AuthProfessionalsPerformanceRoute
  '/_auth/report/opportunity': typeof AuthReportOpportunityRoute
  '/_auth/report/risk': typeof AuthReportRiskRoute
  '/_auth/advisers/': typeof AuthAdvisersIndexRoute
  '/_auth/articles/': typeof AuthArticlesIndexRoute
  '/_auth/bulk-invite/': typeof AuthBulkInviteIndexRoute
  '/_auth/enquiries/': typeof AuthEnquiriesIndexRoute
  '/_auth/professionals/': typeof AuthProfessionalsIndexRoute
  '/_auth/profile/': typeof AuthProfileIndexRoute
  '/_auth/reviews/': typeof AuthReviewsIndexRoute
  '/_auth/tools/': typeof AuthToolsIndexRoute
  '/_auth/top-rated-adviser/': typeof AuthTopRatedAdviserIndexRoute
  '/_auth/top-rated-status/': typeof AuthTopRatedStatusIndexRoute
  '/_auth/elevation/professionals/elevation-performance': typeof AuthElevationProfessionalsElevationPerformanceRoute
  '/_auth/enquiries/report/$id': typeof AuthEnquiriesReportIdRoute
  '/_auth/reviews/first-impression/$id': typeof AuthReviewsFirstImpressionIdRoute
  '/_auth/reviews/review/$id': typeof AuthReviewsReviewIdRoute
  '/_auth/top-rated-status/compare-firms/': typeof AuthTopRatedStatusCompareFirmsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/no-account'
    | '/registration-completion'
    | '/terms'
    | '/two-factor'
    | '/adviser-reputational-tools'
    | '/free-text-analysis'
    | '/invite-history'
    | '/invite-requests'
    | '/performance-adviser'
    | '/performance-adviser-over-time'
    | '/performance-firm'
    | '/performance-firm-over-time'
    | '/performance-over-time'
    | '/reporting'
    | '/review-settings'
    | '/risk-and-opportunity-settings'
    | '/verified-adviser-scores'
    | '/reset-password/$token'
    | '/reset-password/'
    | '/advisers/$id'
    | '/articles/$articleId'
    | '/bulk-invite/$id'
    | '/elevation/firm-performance'
    | '/enquiries/$id'
    | '/network/firms-performance'
    | '/professionals/performance'
    | '/report/opportunity'
    | '/report/risk'
    | '/advisers/'
    | '/articles/'
    | '/bulk-invite/'
    | '/enquiries/'
    | '/professionals/'
    | '/profile/'
    | '/reviews/'
    | '/tools/'
    | '/top-rated-adviser/'
    | '/top-rated-status/'
    | '/elevation/professionals/elevation-performance'
    | '/enquiries/report/$id'
    | '/reviews/first-impression/$id'
    | '/reviews/review/$id'
    | '/top-rated-status/compare-firms/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/no-account'
    | '/registration-completion'
    | '/terms'
    | '/two-factor'
    | '/adviser-reputational-tools'
    | '/free-text-analysis'
    | '/invite-history'
    | '/invite-requests'
    | '/performance-adviser'
    | '/performance-adviser-over-time'
    | '/performance-firm'
    | '/performance-firm-over-time'
    | '/performance-over-time'
    | '/reporting'
    | '/review-settings'
    | '/risk-and-opportunity-settings'
    | '/verified-adviser-scores'
    | '/reset-password/$token'
    | '/'
    | '/reset-password'
    | '/advisers/$id'
    | '/articles/$articleId'
    | '/bulk-invite/$id'
    | '/elevation/firm-performance'
    | '/enquiries/$id'
    | '/network/firms-performance'
    | '/professionals/performance'
    | '/report/opportunity'
    | '/report/risk'
    | '/advisers'
    | '/articles'
    | '/bulk-invite'
    | '/enquiries'
    | '/professionals'
    | '/profile'
    | '/reviews'
    | '/tools'
    | '/top-rated-adviser'
    | '/top-rated-status'
    | '/elevation/professionals/elevation-performance'
    | '/enquiries/report/$id'
    | '/reviews/first-impression/$id'
    | '/reviews/review/$id'
    | '/top-rated-status/compare-firms'
  id:
    | '__root__'
    | '/_auth'
    | '/forgot-password'
    | '/login'
    | '/no-account'
    | '/registration-completion'
    | '/terms'
    | '/two-factor'
    | '/_auth/adviser-reputational-tools'
    | '/_auth/free-text-analysis'
    | '/_auth/invite-history'
    | '/_auth/invite-requests'
    | '/_auth/performance-adviser'
    | '/_auth/performance-adviser-over-time'
    | '/_auth/performance-firm'
    | '/_auth/performance-firm-over-time'
    | '/_auth/performance-over-time'
    | '/_auth/reporting'
    | '/_auth/review-settings'
    | '/_auth/risk-and-opportunity-settings'
    | '/_auth/verified-adviser-scores'
    | '/reset-password/$token'
    | '/_auth/'
    | '/reset-password/'
    | '/_auth/advisers/$id'
    | '/_auth/articles/$articleId'
    | '/_auth/bulk-invite/$id'
    | '/_auth/elevation/firm-performance'
    | '/_auth/enquiries/$id'
    | '/_auth/network/firms-performance'
    | '/_auth/professionals/performance'
    | '/_auth/report/opportunity'
    | '/_auth/report/risk'
    | '/_auth/advisers/'
    | '/_auth/articles/'
    | '/_auth/bulk-invite/'
    | '/_auth/enquiries/'
    | '/_auth/professionals/'
    | '/_auth/profile/'
    | '/_auth/reviews/'
    | '/_auth/tools/'
    | '/_auth/top-rated-adviser/'
    | '/_auth/top-rated-status/'
    | '/_auth/elevation/professionals/elevation-performance'
    | '/_auth/enquiries/report/$id'
    | '/_auth/reviews/first-impression/$id'
    | '/_auth/reviews/review/$id'
    | '/_auth/top-rated-status/compare-firms/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NoAccountRoute: typeof NoAccountRoute
  RegistrationCompletionRoute: typeof RegistrationCompletionRoute
  TermsRoute: typeof TermsRoute
  TwoFactorRoute: typeof TwoFactorRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration-completion': {
      id: '/registration-completion'
      path: '/registration-completion'
      fullPath: '/registration-completion'
      preLoaderRoute: typeof RegistrationCompletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-account': {
      id: '/no-account'
      path: '/no-account'
      fullPath: '/no-account'
      preLoaderRoute: typeof NoAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verified-adviser-scores': {
      id: '/_auth/verified-adviser-scores'
      path: '/verified-adviser-scores'
      fullPath: '/verified-adviser-scores'
      preLoaderRoute: typeof AuthVerifiedAdviserScoresRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/risk-and-opportunity-settings': {
      id: '/_auth/risk-and-opportunity-settings'
      path: '/risk-and-opportunity-settings'
      fullPath: '/risk-and-opportunity-settings'
      preLoaderRoute: typeof AuthRiskAndOpportunitySettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/review-settings': {
      id: '/_auth/review-settings'
      path: '/review-settings'
      fullPath: '/review-settings'
      preLoaderRoute: typeof AuthReviewSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reporting': {
      id: '/_auth/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AuthReportingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance-over-time': {
      id: '/_auth/performance-over-time'
      path: '/performance-over-time'
      fullPath: '/performance-over-time'
      preLoaderRoute: typeof AuthPerformanceOverTimeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance-firm-over-time': {
      id: '/_auth/performance-firm-over-time'
      path: '/performance-firm-over-time'
      fullPath: '/performance-firm-over-time'
      preLoaderRoute: typeof AuthPerformanceFirmOverTimeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance-firm': {
      id: '/_auth/performance-firm'
      path: '/performance-firm'
      fullPath: '/performance-firm'
      preLoaderRoute: typeof AuthPerformanceFirmRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance-adviser-over-time': {
      id: '/_auth/performance-adviser-over-time'
      path: '/performance-adviser-over-time'
      fullPath: '/performance-adviser-over-time'
      preLoaderRoute: typeof AuthPerformanceAdviserOverTimeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/performance-adviser': {
      id: '/_auth/performance-adviser'
      path: '/performance-adviser'
      fullPath: '/performance-adviser'
      preLoaderRoute: typeof AuthPerformanceAdviserRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite-requests': {
      id: '/_auth/invite-requests'
      path: '/invite-requests'
      fullPath: '/invite-requests'
      preLoaderRoute: typeof AuthInviteRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite-history': {
      id: '/_auth/invite-history'
      path: '/invite-history'
      fullPath: '/invite-history'
      preLoaderRoute: typeof AuthInviteHistoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/free-text-analysis': {
      id: '/_auth/free-text-analysis'
      path: '/free-text-analysis'
      fullPath: '/free-text-analysis'
      preLoaderRoute: typeof AuthFreeTextAnalysisRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/adviser-reputational-tools': {
      id: '/_auth/adviser-reputational-tools'
      path: '/adviser-reputational-tools'
      fullPath: '/adviser-reputational-tools'
      preLoaderRoute: typeof AuthAdviserReputationalToolsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/top-rated-status/': {
      id: '/_auth/top-rated-status/'
      path: '/top-rated-status'
      fullPath: '/top-rated-status/'
      preLoaderRoute: typeof AuthTopRatedStatusIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/top-rated-adviser/': {
      id: '/_auth/top-rated-adviser/'
      path: '/top-rated-adviser'
      fullPath: '/top-rated-adviser/'
      preLoaderRoute: typeof AuthTopRatedAdviserIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tools/': {
      id: '/_auth/tools/'
      path: '/tools'
      fullPath: '/tools/'
      preLoaderRoute: typeof AuthToolsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reviews/': {
      id: '/_auth/reviews/'
      path: '/reviews'
      fullPath: '/reviews/'
      preLoaderRoute: typeof AuthReviewsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile/': {
      id: '/_auth/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthProfileIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/professionals/': {
      id: '/_auth/professionals/'
      path: '/professionals'
      fullPath: '/professionals/'
      preLoaderRoute: typeof AuthProfessionalsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/enquiries/': {
      id: '/_auth/enquiries/'
      path: '/enquiries'
      fullPath: '/enquiries/'
      preLoaderRoute: typeof AuthEnquiriesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bulk-invite/': {
      id: '/_auth/bulk-invite/'
      path: '/bulk-invite'
      fullPath: '/bulk-invite/'
      preLoaderRoute: typeof AuthBulkInviteIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/articles/': {
      id: '/_auth/articles/'
      path: '/articles'
      fullPath: '/articles/'
      preLoaderRoute: typeof AuthArticlesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/advisers/': {
      id: '/_auth/advisers/'
      path: '/advisers'
      fullPath: '/advisers/'
      preLoaderRoute: typeof AuthAdvisersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/report/risk': {
      id: '/_auth/report/risk'
      path: '/report/risk'
      fullPath: '/report/risk'
      preLoaderRoute: typeof AuthReportRiskRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/report/opportunity': {
      id: '/_auth/report/opportunity'
      path: '/report/opportunity'
      fullPath: '/report/opportunity'
      preLoaderRoute: typeof AuthReportOpportunityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/professionals/performance': {
      id: '/_auth/professionals/performance'
      path: '/professionals/performance'
      fullPath: '/professionals/performance'
      preLoaderRoute: typeof AuthProfessionalsPerformanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/network/firms-performance': {
      id: '/_auth/network/firms-performance'
      path: '/network/firms-performance'
      fullPath: '/network/firms-performance'
      preLoaderRoute: typeof AuthNetworkFirmsPerformanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/enquiries/$id': {
      id: '/_auth/enquiries/$id'
      path: '/enquiries/$id'
      fullPath: '/enquiries/$id'
      preLoaderRoute: typeof AuthEnquiriesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/elevation/firm-performance': {
      id: '/_auth/elevation/firm-performance'
      path: '/elevation/firm-performance'
      fullPath: '/elevation/firm-performance'
      preLoaderRoute: typeof AuthElevationFirmPerformanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bulk-invite/$id': {
      id: '/_auth/bulk-invite/$id'
      path: '/bulk-invite/$id'
      fullPath: '/bulk-invite/$id'
      preLoaderRoute: typeof AuthBulkInviteIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/articles/$articleId': {
      id: '/_auth/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof AuthArticlesArticleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/advisers/$id': {
      id: '/_auth/advisers/$id'
      path: '/advisers/$id'
      fullPath: '/advisers/$id'
      preLoaderRoute: typeof AuthAdvisersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/top-rated-status/compare-firms/': {
      id: '/_auth/top-rated-status/compare-firms/'
      path: '/top-rated-status/compare-firms'
      fullPath: '/top-rated-status/compare-firms/'
      preLoaderRoute: typeof AuthTopRatedStatusCompareFirmsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reviews/review/$id': {
      id: '/_auth/reviews/review/$id'
      path: '/reviews/review/$id'
      fullPath: '/reviews/review/$id'
      preLoaderRoute: typeof AuthReviewsReviewIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reviews/first-impression/$id': {
      id: '/_auth/reviews/first-impression/$id'
      path: '/reviews/first-impression/$id'
      fullPath: '/reviews/first-impression/$id'
      preLoaderRoute: typeof AuthReviewsFirstImpressionIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/enquiries/report/$id': {
      id: '/_auth/enquiries/report/$id'
      path: '/enquiries/report/$id'
      fullPath: '/enquiries/report/$id'
      preLoaderRoute: typeof AuthEnquiriesReportIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/elevation/professionals/elevation-performance': {
      id: '/_auth/elevation/professionals/elevation-performance'
      path: '/elevation/professionals/elevation-performance'
      fullPath: '/elevation/professionals/elevation-performance'
      preLoaderRoute: typeof AuthElevationProfessionalsElevationPerformanceRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAdviserReputationalToolsRoute: typeof AuthAdviserReputationalToolsRoute
  AuthFreeTextAnalysisRoute: typeof AuthFreeTextAnalysisRoute
  AuthInviteHistoryRoute: typeof AuthInviteHistoryRoute
  AuthInviteRequestsRoute: typeof AuthInviteRequestsRoute
  AuthPerformanceAdviserRoute: typeof AuthPerformanceAdviserRoute
  AuthPerformanceAdviserOverTimeRoute: typeof AuthPerformanceAdviserOverTimeRoute
  AuthPerformanceFirmRoute: typeof AuthPerformanceFirmRoute
  AuthPerformanceFirmOverTimeRoute: typeof AuthPerformanceFirmOverTimeRoute
  AuthPerformanceOverTimeRoute: typeof AuthPerformanceOverTimeRoute
  AuthReportingRoute: typeof AuthReportingRoute
  AuthReviewSettingsRoute: typeof AuthReviewSettingsRoute
  AuthRiskAndOpportunitySettingsRoute: typeof AuthRiskAndOpportunitySettingsRoute
  AuthVerifiedAdviserScoresRoute: typeof AuthVerifiedAdviserScoresRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdvisersIdRoute: typeof AuthAdvisersIdRoute
  AuthArticlesArticleIdRoute: typeof AuthArticlesArticleIdRoute
  AuthBulkInviteIdRoute: typeof AuthBulkInviteIdRoute
  AuthElevationFirmPerformanceRoute: typeof AuthElevationFirmPerformanceRoute
  AuthEnquiriesIdRoute: typeof AuthEnquiriesIdRoute
  AuthNetworkFirmsPerformanceRoute: typeof AuthNetworkFirmsPerformanceRoute
  AuthProfessionalsPerformanceRoute: typeof AuthProfessionalsPerformanceRoute
  AuthReportOpportunityRoute: typeof AuthReportOpportunityRoute
  AuthReportRiskRoute: typeof AuthReportRiskRoute
  AuthAdvisersIndexRoute: typeof AuthAdvisersIndexRoute
  AuthArticlesIndexRoute: typeof AuthArticlesIndexRoute
  AuthBulkInviteIndexRoute: typeof AuthBulkInviteIndexRoute
  AuthEnquiriesIndexRoute: typeof AuthEnquiriesIndexRoute
  AuthProfessionalsIndexRoute: typeof AuthProfessionalsIndexRoute
  AuthProfileIndexRoute: typeof AuthProfileIndexRoute
  AuthReviewsIndexRoute: typeof AuthReviewsIndexRoute
  AuthToolsIndexRoute: typeof AuthToolsIndexRoute
  AuthTopRatedAdviserIndexRoute: typeof AuthTopRatedAdviserIndexRoute
  AuthTopRatedStatusIndexRoute: typeof AuthTopRatedStatusIndexRoute
  AuthElevationProfessionalsElevationPerformanceRoute: typeof AuthElevationProfessionalsElevationPerformanceRoute
  AuthEnquiriesReportIdRoute: typeof AuthEnquiriesReportIdRoute
  AuthReviewsFirstImpressionIdRoute: typeof AuthReviewsFirstImpressionIdRoute
  AuthReviewsReviewIdRoute: typeof AuthReviewsReviewIdRoute
  AuthTopRatedStatusCompareFirmsIndexRoute: typeof AuthTopRatedStatusCompareFirmsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdviserReputationalToolsRoute: AuthAdviserReputationalToolsRoute,
  AuthFreeTextAnalysisRoute: AuthFreeTextAnalysisRoute,
  AuthInviteHistoryRoute: AuthInviteHistoryRoute,
  AuthInviteRequestsRoute: AuthInviteRequestsRoute,
  AuthPerformanceAdviserRoute: AuthPerformanceAdviserRoute,
  AuthPerformanceAdviserOverTimeRoute: AuthPerformanceAdviserOverTimeRoute,
  AuthPerformanceFirmRoute: AuthPerformanceFirmRoute,
  AuthPerformanceFirmOverTimeRoute: AuthPerformanceFirmOverTimeRoute,
  AuthPerformanceOverTimeRoute: AuthPerformanceOverTimeRoute,
  AuthReportingRoute: AuthReportingRoute,
  AuthReviewSettingsRoute: AuthReviewSettingsRoute,
  AuthRiskAndOpportunitySettingsRoute: AuthRiskAndOpportunitySettingsRoute,
  AuthVerifiedAdviserScoresRoute: AuthVerifiedAdviserScoresRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdvisersIdRoute: AuthAdvisersIdRoute,
  AuthArticlesArticleIdRoute: AuthArticlesArticleIdRoute,
  AuthBulkInviteIdRoute: AuthBulkInviteIdRoute,
  AuthElevationFirmPerformanceRoute: AuthElevationFirmPerformanceRoute,
  AuthEnquiriesIdRoute: AuthEnquiriesIdRoute,
  AuthNetworkFirmsPerformanceRoute: AuthNetworkFirmsPerformanceRoute,
  AuthProfessionalsPerformanceRoute: AuthProfessionalsPerformanceRoute,
  AuthReportOpportunityRoute: AuthReportOpportunityRoute,
  AuthReportRiskRoute: AuthReportRiskRoute,
  AuthAdvisersIndexRoute: AuthAdvisersIndexRoute,
  AuthArticlesIndexRoute: AuthArticlesIndexRoute,
  AuthBulkInviteIndexRoute: AuthBulkInviteIndexRoute,
  AuthEnquiriesIndexRoute: AuthEnquiriesIndexRoute,
  AuthProfessionalsIndexRoute: AuthProfessionalsIndexRoute,
  AuthProfileIndexRoute: AuthProfileIndexRoute,
  AuthReviewsIndexRoute: AuthReviewsIndexRoute,
  AuthToolsIndexRoute: AuthToolsIndexRoute,
  AuthTopRatedAdviserIndexRoute: AuthTopRatedAdviserIndexRoute,
  AuthTopRatedStatusIndexRoute: AuthTopRatedStatusIndexRoute,
  AuthElevationProfessionalsElevationPerformanceRoute:
    AuthElevationProfessionalsElevationPerformanceRoute,
  AuthEnquiriesReportIdRoute: AuthEnquiriesReportIdRoute,
  AuthReviewsFirstImpressionIdRoute: AuthReviewsFirstImpressionIdRoute,
  AuthReviewsReviewIdRoute: AuthReviewsReviewIdRoute,
  AuthTopRatedStatusCompareFirmsIndexRoute:
    AuthTopRatedStatusCompareFirmsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NoAccountRoute: NoAccountRoute,
  RegistrationCompletionRoute: RegistrationCompletionRoute,
  TermsRoute: TermsRoute,
  TwoFactorRoute: TwoFactorRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
